/* eslint-disable global-require */
/**
 * Module dependencies
 */

/**
 * Send metric to StatsD/Datadog through API
 * @param {string} metricName - Name of the metric to track
 * @param {number} value - Value to record
 * @param {Object} options - Additional options (type, sampleRate, tags)
 * @returns {Promise} API response
 */
const sendMetric = (metricName, value, options = {}) => {
  try {
    const domPageToken = document.querySelector('meta[name="page-token"]');
    const pageToken = domPageToken ? domPageToken.getAttribute('content') : '';
    const browserRestClient = require('../utils/restclient-browser')();

    return browserRestClient.post('/metrics', {
      headers: { 'CSRF-Token': pageToken },
      data: {
        metricName,
        value,
        type: options.type || 'gauge',
        sampleRate: options.sampleRate || 1,
        tags: options.tags || {},
      },
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

/**
 * Send timing metric
 * @param {string} metricName - Name of the metric
 * @param {number} duration - Duration in milliseconds
 * @param {Object} options - Additional options (sampleRate, tags)
 * @returns {Promise} API response
 */
const timing = (metricName, duration, options = {}) => sendMetric(metricName, duration, {
  ...options,
  type: 'timing',
});

/**
 * Increment a metric counter
 * @param {string} metricName - Name of the metric
 * @param {number} value - Increment value
 * @param {Object} options - Additional options (sampleRate, tags)
 * @returns {Promise} API response
 */
const increment = (metricName, value = 1, options = {}) => sendMetric(metricName, value, {
  ...options,
  type: 'increment',
});

/**
 * Send gauge metric
 * @param {string} metricName - Name of the metric
 * @param {number} value - Gauge value
 * @param {Object} options - Additional options (sampleRate, tags)
 * @returns {Promise} API response
 */
const gauge = (metricName, value, options = {}) => sendMetric(metricName, value, {
  ...options,
  type: 'gauge',
});

module.exports = {
  sendMetric,
  timing,
  increment,
  gauge,
};
